import PriorityBlockerIcon from '@atlaskit/icon/core/priority-blocker';
import * as React from 'react';

export function SvgMinusCircle() {
  return <PriorityBlockerIcon label="" testId="ads-refreshed-icon" />;
}
